import { createFieldChecks } from '@avrahami/ui';
import { he } from '../i18n/he';

const checks = createFieldChecks({
  validation: he.validation,
  invalidField: he.common.invalidField,
  required: he.common.required,
  taken: he.common.taken,
});

/** The contracts' rules and the API's refusals as messages per field (see `@avrahami/ui`). */
export const { parseWith, mergeErrors, serverFieldErrors } = checks;
